module.exports = __webpack_public_path__ + "static/img/hxzz_gzh.76e0bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hxzz_gzh.png
// module id = cuK1
// module chunks = 169